import { render, staticRenderFns } from "./ServicesPopup.vue?vue&type=template&id=72a0dbf1&scoped=true&"
import script from "./ServicesPopup.vue?vue&type=script&lang=js&"
export * from "./ServicesPopup.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPopup.vue?vue&type=style&index=0&id=72a0dbf1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a0dbf1",
  null
  
)

export default component.exports